import identityService from '@/shared/services/IdentityService'
import type { LoginRequest } from '@/shared/services/IdentityService/components/identity.param'
import { STORAGE, setAuthToken, setLocalStorage, setRefreshToken } from '@/shared/utils/storage'
import { useMutation } from '@tanstack/react-query'

export const useLogin = () =>
  useMutation({
    mutationFn: async (payload: LoginRequest) => {
      const res = await identityService.login(payload)
      if (res.isError) throw new Error(res.errorMessage || 'Đăng nhập thất bại')
      // remember lấy từ checkbox "Ghi nhớ mật khẩu" (FE2): false → lưu sessionStorage
      // (mất khi đóng tab), true → lưu localStorage. Trước đây hard-code true.
      const remember = !!payload.remember
      // HQC-258: persist remember flag để setAuthToken/setRefreshToken (kể cả lúc
      // refresh) đọc đúng tầng storage khớp lựa chọn "Ghi nhớ" lúc login.
      setLocalStorage(STORAGE.REMEMBER_HOME, remember)

      const token = res.object?.token ?? res.object?.Token
      const refreshToken = res.object?.refreshToken ?? res.object?.RefreshToken

      if (token) setAuthToken(token, remember)
      if (refreshToken) setRefreshToken(refreshToken, remember)
      // login response đã trả đủ user info — lưu luôn, không cần gọi thêm API getInfo
      // (BE TXNG không có route /api/identity/getInfo tương ứng)
      setLocalStorage(STORAGE.USER_INFO, res.object)
      return res.object
    },
  })
